export default __webpack_public_path__ + "maps-examples-offline-pack-thumbnail-480-37c16097183c4939fd66d0f4f070af2f.webp";